module.exports = __webpack_public_path__ + "img/bannerimg4.1a1c18e0.png";